import { Component, OnInit } from '@angular/core';
import { AuthService } from './injections/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'Hola mundo';
  constructor(private login: AuthService){}

  saveOnLocalStorage(user) {
    user = JSON.stringify(user);
    localStorage.setItem("user",user);
  }

  getFromLocalStorage() {
    return JSON.parse(localStorage.getItem("user"));
  }

  getUserLogued(){
    if(localStorage.getItem("user") != null){
      return true;
    }else{
      return false;
    }
  }

  ngOnInit() {
   
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts